import React from 'react';
import AboutContent from './AboutContent';
import ContactUpdated from './ContactUpdated';
import Footer from './Footer';


const About = () => {
  return (
    <div className=''>
        <AboutContent />
        <ContactUpdated />
        <Footer />
    </div>
  )
}

export default About;